// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '531140c8', builtAt: '2026-11-03 23:29 UTC' };
